import { render } from "./ControleDePAP.vue?vue&type=template&id=fbf836a6"
import script from "./ControleDePAP.vue?vue&type=script&lang=js"
export * from "./ControleDePAP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__